<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong>{{$t('payrollReport')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton
                    class="mr-1"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>

              </CCol>
            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CCardBody>

            <CRow>
              <CCol col="3">
                <date-picker

                    :label="$t('components.startDate')"
                    v-model="start_date"></date-picker>
              </CCol>
              <CCol col="3" v-if="1==0">
                <date-picker

                    :label="$t('components.endDate')"
                    v-model="end_date"></date-picker>

              </CCol>
              <CCol col="3">
                <CInput
horizontal

                    :label="$t('components.name')"
                    v-model="search_name"></CInput>

              </CCol>
              <CCol col="1">
                <CButton @click="get_lists()" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
<!--              <CCol col="3">-->
<!--                <CSelect-->
<!--                    horizontal-->
<!--                    :label="$t('branch')"/>-->

<!--              </CCol>-->
<!--              <CCol col="3">-->
<!--                <label style="float: right" >  {{$t('totalSum')}} : {{get_currency(get_total_price(items_customer))}}</label>-->

<!--              </CCol>-->

            </CRow>
            <CDataTableFixed
                :items="items_customer_filtered"
                :fields="fields"
                column-filter
                :items-per-page="1000"
                hover
                @row-clicked="table_row_clicked"
height="320px"
                sorter

            >
              <template #row_id="{item,index}">
                <td>
                  <p style="text-align: center">{{ index + 1 }}</p>
                </td>
              </template>

              <template #masterCode="{item}">
                <td>
                  <p style="text-align: center">{{ item.masterCode }}</p>
                </td>
              </template>

              <template #docNo="{item}">
                <td>
                  <p style="text-align: center">{{ item.docNo }}</p>
                </td>
              </template>



              <template #createdBy="{item}">
                <td>
                  <p style="text-align: center">{{ item.createdBy}}</p>
                </td>
              </template>
              <template #createdAt="{item}">
                <td>
                  <p style="text-align: center">{{ get_date(item.createdAt)}}</p>
                </td>
              </template>
              <template #fromDate="{item}">
                <td>
                  <p >{{ get_date(item.fromDate)}}</p>
                </td>
              </template>
              <template #fromDate="{item}">
                <td>
                  <p >{{ get_date(item.fromDate)}}</p>
                </td>
              </template>
              <template #toDate="{item}">
                <td>
                  <p >{{ get_date(item.toDate)}}</p>
                </td>
              </template>
              <template #amount="{item}">
                <td>
                  <p style="text-align:right">{{ get_currency(calculate_items(item.details,"amount"))}}</p>
                </td>
              </template>

              <template #operation="{item}">
                <td>
                  <CIcon v-if="item.recStatus==0" @click.native="open_for_edit(item)" class="text-primary mr-1 ml-1" name="cil-pencil"/>

                </td>
              </template>

            </CDataTableFixed>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items_data = [];

import moment from 'moment-jalaali'

export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      name: '',
      file: '',
      search_name:'',
      color: '#ffffff',
      previewImage: '',
      selected_template: 0,
      description: '',
      saleMethodModal: false,
      method_list: [],
      selected_method: '',
      selected_person: 0,
      start_date: '',
      end_date: '',
      items_customer: [],
      items_customer_filtered: [],
      fields: [
        {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'docNo', label: this.$t('docNumber'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('prlNo'), _style: 'width:10%'},
        {key: 'fromDate', label: this.$t('startDate'), _style: 'width:10%'},
        {key: 'toDate', label: this.$t('components.endDate'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:10%'},
        {key: 'createdBy', label: this.$t('docCreator'), _style: 'width:10%'},
        {key: 'createdAt', label: this.$t('payDate'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%'},

      ],
      items_worker: [],
      // fields,

      items_vendor: [],
      // fields,

      details: [],

      collapseDuration: 0,
      table_clicks:0,
      table_clicks_timer:null,
      status_form: 0
    }
  },

  mounted() {
    // this.start_date = moment().utc().format('YYYY/MM/DD');
    // this.end_date = moment().utc().format('YYYY/MM/DD');
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();
    this.get_lists();
    this.$root.root_validate_errors = [];
    // this.get_method_lists();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on("sallary_update", (data) => {
      // alert(data);
        this.get_lists();

    });
  }, watch: {
    'start_date': function () {
      this.get_lists();
    },
    'end_date': function () {
      this.get_lists();
    },
    'search_name': function () {
      if(this.search_name==""){
        this.items_customer_filtered = this.items_customer;
      }else{
        console.log("search includes",this.search_name)

        // this.items_customer_filtered = [];
        this.items_customer_filtered = this.items_customer.filter(x=>x.details.filter(y=>y.personName.toLocaleLowerCase().includes(this.search_name.toLocaleLowerCase())).length>0)
      }

    },
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.table_clicks_timer=0;
        this.table_clicks = 0

        window.open('/dashboard/users/payroll-view/'+item.masterId)
      }

    },
    open_for_edit(item){
      window.open('/dashboard/users/payroll-view/'+item.masterId)

    },
    get_total_price(item){
      var total_price = 0;
      item.forEach((val) => {
       total_price += parseInt(val.payable)
        // console.log(val.payable,total_price);

      });
      return total_price;
    },
    get_method_lists() {
      var self = this;

      const formData = new FormData();


      axios.post('GetPriceMethodTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          content_data.data.forEach((val) => {
            var obj = {label: val.title, value: val.id}

            self.method_list.push(obj);
          });
          if (self.$route.params.area_id == null) {
            self.get_lists();

          } else {
            self.get_listsByArea();

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      var url = "GetPayrollDocList";

      formData.append('CostCenterID', 0);
      formData.append('Id', 0);
      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);




      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // response.data.data.forEach((val) =>{
          //  self.items_customer = self.items_customer.concat(val.details);
         // });
          self.items_customer = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_customer_filtered = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    prepare_salary(){
      for(var i=0;i<this.items_customer.length;i++){
        if(this.items_customer[i].Wage && this.items_customer[i].hours && this.items_customer[i].penaltyHours  ){
          this.add_salary(this.items_customer[i])
        }
      }
    },
    add_salary(item) {
      var self = this;


      const formData = new FormData();

      var url = "UserSallary/Add";

      formData.append('FirstDate', this.start_date);
      formData.append('SecondDate', this.end_date);
      formData.append('PersonId', item.userId);
      formData.append('Sallary', item.Wage);
      formData.append('JobHours', item.hours);
      formData.append('CostCenterId', 0);
      formData.append('Penalty', item.penaltyHours);
      formData.append('Total', item.hours - item.penaltyHours);
      formData.append('TotalPrice', item.Wage *(item.hours - item.penaltyHours));


      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.map((item, row_id) => {
// if(item.isCustomer){
            return {...item, row_id}

// }
          });


          self.items_worker = content_data.data.map((item, row_id) => {
            // if(item.isCustomer){
            return {...item, row_id}

            // }
          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },



  }
}

</script>
